module.exports = "<div class=\"last-sync\">\n  <span>{{ vm.batchStatus | translate }}</span>\n  <span ng-if=\"vm.batchHasFinished()\"> : {{vm.lastBatchDateTime}}</span>\n  <span ng-if=\"vm.isInProcess()\"class=\"spinner errorReport__spinner\">\n    <div class=\"bounce1\"></div>\n    <div class=\"bounce2\"></div>\n    <div class=\"bounce3\"></div>\n  </span>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./app/components/statusIndicator/statusIndicator.html
// module id = 355
// module chunks = 1